import { IJoinToGroupsGridItem, IJoinToGroupsPayload } from "../types";

const isTgmGroup = (item: IJoinToGroupsGridItem) => Boolean(item.restrictedGroupId);

const createTgmMember = (item: IJoinToGroupsGridItem): IJoinToGroupsGridItem => ({
  ...item,
  // TODO: https://cayosoft.visualstudio.com/PolicyManager/_workitems/edit/33176/
  StartMode: 0,
  StartValue: null,
  EndMode: 1,
  EndValue: 24,
  EndDate: "after 24 hours",
});

export const formatJoinToGroupsPayload = (items: IJoinToGroupsGridItem[]): IJoinToGroupsPayload => {
  return items.reduce<IJoinToGroupsPayload>(
    (result, item) => {
      const newItem = {
        ...item,
        newAddedFlag: true,
      };

      if (isTgmGroup(item)) {
        result.tgmMembers.push(createTgmMember(newItem));
      } else {
        result.addedMembers.push(newItem);
      }

      return result;
    },
    {
      addedMembers: [],
      removedMembers: [],
      tgmMembers: [],
    }
  );
};
